import { useElectronUpdaterContext } from '~/providers/ElectronUpdaterContext'
import { isElectron } from '~/utils/common'

import { appUpdatesHealth, type HealthRow } from './statusHealth'

/** Desktop-only App updates health; null in the browser, where the row is hidden. */
export function useAppUpdatesHealth(): HealthRow | null {
  const {
    updatePermissionHelpUrl,
    isUpdateBlocked,
    isUpdateAvailable,
    isUpdateDownloaded,
    availableVersion,
    lastCheckStatus,
    isChecking,
  } = useElectronUpdaterContext()

  if (!isElectron) return null

  return appUpdatesHealth({
    isInstallPermissionMissing: Boolean(updatePermissionHelpUrl),
    isUpdateBlocked,
    isUpdateAvailable,
    isUpdateDownloaded,
    availableVersion,
    lastCheckStatus,
    isChecking,
  })
}
